import "./footer.css";
import footerImg from "../../assets/footer.png";

export default function Footer() {
    return (
        <footer className="public-footer">
            <div className="public-footer-inner">
                <img src={footerImg} alt="Footer Maggioli" />
                <a href="https://privacy.maggiolicloud.it/privacy/brainbitesmaggiolicloudit" target="_blank" rel="noreferrer">
                    Privacy policy
                </a>
            </div>
        </footer>
    );
}
